import React from 'react';
import { ChevronRight } from 'lucide-react';
import { IconButton } from './IconButton.js';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumb?: React.ReactNode;
  backButton?: React.ReactNode;
  onBack?: () => void;
  actions?: React.ReactNode;
  actionsClassName?: string;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  breadcrumb,
  backButton,
  onBack,
  actions,
  actionsClassName = 'flex',
  className = ''
}) => {
  const backButtonNode =
    backButton ??
    (onBack ? (
      <IconButton
        label="بازگشت"
        icon={<ChevronRight className="size-5" />}
        variant="ghost"
        size="md"
        onClick={onBack}
        className="shrink-0"
      />
    ) : null);

  return (
    <header
      className={`flex flex-col md:flex-row md:items-center justify-between gap-4 ${className}`}
    >
      <div className="flex flex-col min-w-0 flex-1">
        {breadcrumb && (
          <nav
            aria-label="مسیر راهنما"
            className="text-xs text-base-content/60 flex items-center gap-1.5 mb-1.5"
          >
            {breadcrumb}
          </nav>
        )}
        <div className="flex items-center gap-3 min-w-0">
          {backButtonNode}
          <div className="flex flex-col min-w-0 flex-1">
            <h1 className="text-[22px] lg:text-2xl font-bold text-base-content tracking-tight truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-[13px] md:text-sm text-base-content/60 mt-1">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
      {actions && (
        <div className={`${actionsClassName} items-center gap-2 shrink-0 flex-wrap`}>
          {actions}
        </div>
      )}
    </header>
  );
};

PageHeader.displayName = 'PageHeader';
